export default __webpack_public_path__ + "static/media/TheSmarmyBum - 1589.4c204ed3.jpeg";